// Central visibility switches for PUBLIC features (navigation links, homepage sections, promo copy,
// product-card actions). Turning a flag off only hides entry points: implementation code, database
// tables and routes are untouched, and SEO eligibility is NOT affected. Indexing is decided separately
// by seo/sitemap-manifest.json (see src/utils/seoPolicy.js).
export const publicFeatures = {
  home: true,
  categories: true,
  search: true,
  productDetails: true,
  buyingGuides: true,

  comparisons: false,
  trending: false,
  priceHistory: false,
  pricePredictions: false,
  dailyDeals: false,
  priceAlerts: false,
};

export function isFeatureEnabled(name, features = publicFeatures) {
  return features[name] === true;
}
